// @ts-nocheck
import React, { useState } from "react";
import Stepper from "@mui/material/Stepper";
import Step from "@mui/material/Step";
import StepLabel from "@mui/material/StepLabel";
import Button from "@mui/material/Button";
import StepConnector from "@mui/material/StepConnector";
import { styled } from "@mui/system";
import CheckIcon from "@mui/icons-material/Check";
import { getIsWiredTransfer } from "../utils/config";

// Custom Step Icon for active and completed steps
const CustomStepIconRoot = styled("div")(({ theme, ownerState }) => ({
  backgroundColor: ownerState.completed ? "#4caf50" : "#FFF",
  border: !ownerState.completed && !ownerState.active && "1.5px solid grey",
  zIndex: 1,
  color: "#fff",
  width: 20,
  height: 20,
  display: "flex",
  borderRadius: "50%",
  justifyContent: "center",
  alignItems: "center",
  ...(ownerState.active && {
    backgroundColor: "#4caf50",
  }),
}));

// Custom Step Connector to connect the icons with a line
const CustomStepConnector = styled(StepConnector)(({ theme }) => ({
  top: 10,
  left: "calc(-50% + 13px)",
  right: "calc(50% + 13px)",
  [`& .MuiStepConnector-line`]: {
    height: 1,
    border: 0,
    backgroundColor: "#e0e0e0",
    borderRadius: 1,
  },
}));

// StepIcon component that customizes the look of the step icons
const CustomStepIcon = (props) => {
  const { active, completed, className } = props;

  return (
    <CustomStepIconRoot
      ownerState={{ completed, active }}
      className={className}
    >
      {completed ? (
        <CheckIcon
          sx={{
            height: 18,
            width: 18,
            p:"2px"
          }}
        />
      ) : (
        <div className="w-3 h-3 rounded-full md:bg-white" />
      )}
    </CustomStepIconRoot>
  );
};

const StepperComponent = ({ activeStep, isMobile }) => {
  const steps = [
    "Identity Verification",
    "Bidding Agreement",
    getIsWiredTransfer() === "1"?  "Add Funds" :!isMobile ? "Link Your Bank Account" : "Link Your Bank",
  ];
  // State to track the active step
  return (
    <div className="md:w-[45%] mx-auto bg-white shadow-sm border-[#C5C9CD] py-2">
        <p className="text-center text-base font-medium hidden md:block mb-4">
          Please complete the following:
        </p>
      <Stepper
        activeStep={activeStep}
        alternativeLabel
        connector={<CustomStepConnector />}
      >
        {steps.map((label, index) => (
          <Step key={label}>
            <StepLabel
              sx={{
                ".MuiStepLabel-label.MuiStepLabel-alternativeLabel": {
                  mt: 1,
                },
              }}
              StepIconComponent={CustomStepIcon}
            >
              <span
                className={`text-xs md:text-sm ${index <= activeStep ? "text-green-600" : "text-gray-400"
                  } mt-[-10px]`}
              >
                {label}
              </span>
            </StepLabel>
          </Step>
        ))}
      </Stepper>
    </div>
  );
};

export default StepperComponent;

